import { NamedEntity } from '../types';

export const formatCodeName = (entity?: NamedEntity | null) => {
  if (!entity || (!entity.code && !entity.name)) {
    return '';
  }

  const { code, name } = entity;
  return `${code} - ${name}`;
};

export const formatNumber = (num: number) => {
  const parts = num.toString().split('.');

  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ') +
    (parts[1] ? '.' + parts[1] : '')
  );
};

export function padZero(num: number, targetLength = 2) {
  return num.toString().padStart(targetLength, '0');
}

export const formatBoolean = (value?: any) => {
  if (typeof value === 'boolean') {
    return value;
  } else if (typeof value === 'string') {
    return value.toLowerCase() === 'true';
  } else return !!value;
};
